// src/utils/storyEngineFieldConfig.js

export const STORY_ENGINE_FIELD_CONFIG = {
  consultationMapped: [
    {
      key: 'artistName',
      label: 'Artist Name',
      inputType: 'text',
      suggestable: false,
    },
    {
      key: 'projectName',
      label: 'Project Name',
      inputType: 'text',
      suggestable: false,
    },
    {
      key: 'primaryUseCase',
      label: 'Primary Use Case',
      inputType: 'text',
      suggestable: true,
      recommendationKey: 'primaryUseCase',
    },
    {
      key: 'styleOfPlaying',
      label: 'Style of Playing',
      inputType: 'text',
      suggestable: true,
      recommendationKey: 'styleOfPlaying',
    },
    {
      key: 'diameter',
      label: 'Diameter',
      inputType: 'text',
      suggestable: false,
    },
    {
      key: 'depth',
      label: 'Depth',
      inputType: 'text',
      suggestable: false,
    },
    {
      key: 'genreContext',
      label: 'Genre Context',
      inputType: 'text',
      suggestable: true,
      recommendationKey: 'genreContext',
    },
    {
      key: 'desiredOutcome',
      label: 'Desired Outcome',
      inputType: 'text',
      suggestable: true,
      recommendationKey: 'desiredOutcome',
    },
    {
      key: 'currentPainPoints',
      label: 'Current Pain Points',
      inputType: 'text',
      suggestable: true,
      recommendationKey: 'currentPainPoints',
    },
    {
      key: 'influenceReferences',
      label: 'Influence References',
      inputType: 'text',
      suggestable: true,
      recommendationKey: 'influenceReferences',
    },
    {
      key: 'visualMood',
      label: 'Visual Mood',
      inputType: 'text',
      suggestable: true,
      recommendationKey: 'visualMood',
    },
    {
      key: 'finishDirection',
      label: 'Finish Direction',
      inputType: 'text',
      suggestable: true,
      recommendationKey: 'finishDirection',
    },
    {
      key: 'woodPreference',
      label: 'Wood Preference',
      inputType: 'text',
      suggestable: true,
      recommendationKey: 'woodPreference',
    },
    {
      key: 'attack',
      label: 'Attack',
      inputType: 'text',
      suggestable: true,
      recommendationKey: 'attack',
    },
    {
      key: 'body',
      label: 'Body',
      inputType: 'text',
      suggestable: true,
      recommendationKey: 'body',
    },
    {
      key: 'sensitivity',
      label: 'Sensitivity',
      inputType: 'text',
      suggestable: true,
      recommendationKey: 'sensitivity',
    },
    {
      key: 'sustain',
      label: 'Sustain',
      inputType: 'text',
      suggestable: true,
      recommendationKey: 'sustain',
    },
    {
      key: 'projection',
      label: 'Projection',
      inputType: 'text',
      suggestable: true,
      recommendationKey: 'projection',
    },
    {
      key: 'tuningRange',
      label: 'Tuning Range',
      inputType: 'text',
      suggestable: true,
      recommendationKey: 'tuningRange',
    },
    {
      key: 'articulation',
      label: 'Articulation',
      inputType: 'text',
      suggestable: true,
      recommendationKey: 'articulation',
    },
    {
      key: 'feel',
      label: 'Feel',
      inputType: 'text',
      suggestable: true,
      recommendationKey: 'feel',
    },
        {
      key: 'responsePriorities',
      label: 'Response Priorities',
      inputType: 'text',
      suggestable: true,
      recommendationKey: 'responsePriorities',
    },
    {
      key: 'tonalGoals',
      label: 'Tonal Goals',
      inputType: 'text',
      suggestable: true,
      recommendationKey: 'tonalGoals',
    },
    {
      key: 'preferredSizeDirection',
      label: 'Preferred Size Direction',
      inputType: 'text',
      suggestable: true,
      recommendationKey: 'preferredSizeDirection',
    },
  ],

  questionnaireMapped: [
    {
      key: 'artistName',
      label: 'Artist Name',
      inputType: 'text',
      suggestable: false,
    },
    {
      key: 'styleOfPlaying',
      label: 'Style of Playing',
      inputType: 'text',
      suggestable: true,
      recommendationKey: 'styleOfPlaying',
    },
    {
      key: 'desiredOutcome',
      label: 'Desired Outcome',
      inputType: 'text',
      suggestable: true,
      recommendationKey: 'desiredOutcome',
    },
    {
      key: 'genreContext',
      label: 'Genre Context',
      inputType: 'text',
      suggestable: true,
      recommendationKey: 'genreContext',
    },
    {
      key: 'recordingUse',
      label: 'Recording Use',
      inputType: 'text',
      suggestable: true,
      recommendationKey: 'recordingUse',
    },
    {
      key: 'liveUse',
      label: 'Live Use',
      inputType: 'text',
      suggestable: true,
      recommendationKey: 'liveUse',
    },
    {
      key: 'influenceReferences',
      label: 'Influence References',
      inputType: 'text',
      suggestable: true,
      recommendationKey: 'influenceReferences',
    },
    {
      key: 'hardwareFinish',
      label: 'Hardware Finish',
      inputType: 'text',
      suggestable: true,
      recommendationKey: 'hardwareFinish',
    },
    {
      key: 'woodPreference',
      label: 'Wood Preference',
      inputType: 'text',
      suggestable: true,
      recommendationKey: 'woodPreference',
    },
    {
      key: 'finishDirection',
      label: 'Finish Direction',
      inputType: 'text',
      suggestable: true,
      recommendationKey: 'finishDirection',
    },
        {
      key: 'responsePriorities',
      label: 'Response Priorities',
      inputType: 'text',
      suggestable: true,
      recommendationKey: 'responsePriorities',
    },
    {
      key: 'tonalGoals',
      label: 'Tonal Goals',
      inputType: 'text',
      suggestable: true,
      recommendationKey: 'tonalGoals',
    },
    {
      key: 'preferredSizeDirection',
      label: 'Preferred Size Direction',
      inputType: 'text',
      suggestable: true,
      recommendationKey: 'preferredSizeDirection',
    },
    {
      key: 'consultationContactMethod',
      label: 'Consultation Contact Method',
      inputType: 'text',
      suggestable: true,
      recommendationKey: 'consultationContactMethod',
    },
  ],
};

export const STORY_ENGINE_BUILD_SPEC_FIELDS = [
  {
    key: 'shellConstruction',
    label: 'Shell Construction',
    inputType: 'select',
    options: ['Stave', 'Steam Bent', 'Ply', 'Hybrid'],
    recommendationKey: 'shellConstruction',
  },
  {
    key: 'primaryWood',
    label: 'Primary Wood',
    inputType: 'select',
    options: ['Maple', 'Walnut', 'Cherry', 'Mahogany', 'Oak', 'Birch'],
    recommendationKey: 'primaryWood',
  },
  {
    key: 'secondaryWood',
    label: 'Secondary Wood',
    inputType: 'select',
    options: ['None', 'Maple', 'Walnut', 'Cherry', 'Mahogany', 'Oak', 'Birch'],
    recommendationKey: 'secondaryWood',
  },
  {
    key: 'bearingEdge',
    label: 'Bearing Edge',
    inputType: 'select',
    options: [
      '45-degree',
      '45-degree with softened outer round-over',
      'Round-over',
      'Baseball bat',
    ],
    recommendationKey: 'bearingEdge',
  },
  {
    key: 'hoopType',
    label: 'Hoop Type',
    inputType: 'select',
    options: ['Die-cast hoops', 'Triple-flanged hoops', 'Brass hoops'],
    recommendationKey: 'hoopType',
  },
  {
    key: 'lugCount',
    label: 'Lug Count',
    inputType: 'select',
    options: ['6 lug', '8 lug', '10 lug'],
    recommendationKey: 'lugCount',
  },
  {
    key: 'tuningApproach',
    label: 'Tuning Approach',
    inputType: 'text',
    recommendationKey: 'tuningApproach',
  },
  {
    key: 'finishSystem',
    label: 'Finish System',
    inputType: 'text',
    recommendationKey: 'finishSystem',
  },
  {
    key: 'snareBed',
    label: 'Snare Bed',
    inputType: 'text',
    recommendationKey: 'snareBed',
  },
];